export default {
  loadingWebsites: "Loading sites...",
  website: "Website",
  websiteLoading: "Loading organisations/institutions",
};
